import { AuthUser } from "entities/auth";
import { UserRole } from "entities/common";

export const canManageIaqLimits = (user?: AuthUser | null): boolean => {
  if (!user) {
    return false;
  }

  return user.role === UserRole.ADMINISTRATOR || Boolean(user.manages_any_asset);
};
